import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { FileField, FileInput as RaFileInput } from "react-admin";

const styles = (theme) => ({
	image: {
		margin: 0,
		marginTop: theme.spacing(1),
		borderRadius: 5,
		border: "1px solid #d3d3d3",
	},
});

const useStyles = makeStyles(styles);

const CsvField = (props) => {
	const classes = useStyles();
	return <FileField classes={classes} {...props} />;
};

const CsvInput = (props) => (
	<RaFileInput {...props} accept=".csv" multiple={false}>
		<CsvField source="path" />
	</RaFileInput>
);
export default CsvInput;
